<template>
  <el-dialog width="80%" title="Restriçoes" :visible.sync="dialog" append-to-body>
    <el-form :model="ruleForm" ref="ruleForm" label-position="right" label-width="120px">
      <el-form-item class="is-required">
        <el-radio-group v-model="ruleForm.type">
          <el-radio label="include">Permitir</el-radio>
          <el-radio label="exclude">Restringir</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-row :gutter="5">
        <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
          <el-form-item :label="$t('origem')" prop="source" class="is-required">
            <CapitalStateList @selected="selectedSource" :current="ruleForm.source.state"/>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="5">
        <el-col :xs="12" :sm="8" :md="8" :lg="6" :xl="6">
          <el-form-item :label="$t('cep')" prop="cep">
            <el-input maxlength="9" v-model="ruleForm.source.zipcodeStart" v-mask="'#####-###'"></el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="12" :sm="8" :md="8" :lg="6" :xl="6">
          <el-form-item label="à" prop="address">
            <el-input maxlength="9" v-model="ruleForm.source.zipcodeEnd" v-mask="'#####-###'"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="5">
        <el-col :xs="12" :sm="24" :md="18" :lg="12" :xl="12">
          <el-form-item :label="$t('destino')" prop="neighborhood" class="is-required">
            <CapitalStateList @selected="selectedDestiny" :multiple="true"  :current="ruleForm.destiny.state"/>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="5">
        <el-col :xs="12" :sm="8" :md="8" :lg="6" :xl="6">
          <el-form-item :label="$t('cep')" prop="cep">
            <el-input maxlength="9" v-model="ruleForm.destiny.zipcodeStart" v-mask="'#####-###'"></el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="12" :sm="8" :md="8" :lg="6" :xl="6">
          <el-form-item label="à" prop="address">
            <el-input maxlength="9" v-model="ruleForm.destiny.zipcodeEnd" v-mask="'#####-###'"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialog = false">Cancelar</el-button>
      <el-button type="warning" @click="add">Adicionar</el-button>
    </span>
  </el-dialog>
</template> 
<script>
import StateList from "../../../../services/search.cep/StateList.vue";
import CapitalStateList from "./CapitalStateList.vue";

export default {
  name: "ShippingAddFormRestrictedAdd",
  props: ['tableData'],
  data() {
    return {
      dialog: false,
      edition: false,
      ruleForm: {
        source: {
          state: "",
          zipcodeStart: "",
          zipcodeEnd: '',
        },
        destiny: {
          state: "",
          zipcodeStart: "",
          zipcodeEnd: '',
        },
        type: 'include',
      }
    };
  },
  methods: {
    selectedSource(stateData) {
      this.ruleForm.source.state = stateData.state;
      this.ruleForm.source.zipcodeStart = stateData.zipcodeStart;
      this.ruleForm.source.zipcodeEnd = stateData.zipcodeFinal;
    },
    selectedDestiny(stateData) {
      this.ruleForm.destiny.state = stateData.state;
      this.ruleForm.destiny.zipcodeStart = stateData.zipcodeStart;
      this.ruleForm.destiny.zipcodeEnd = stateData.zipcodeFinal;
    },
    open(data) {
      this.ruleForm = data || {
        source: {
          state: "",
          zipcodeStart: "",
          zipcodeEnd: '',
        },
        destiny: {
          state: [],
          zipcodeStart: "",
          zipcodeEnd: '',
        },
        type: 'include',
      };
      if (data) this.edition = true;
      this.dialog = true;
    },
    add() {
      const vm = this;
      if (!vm.ruleForm.source.state && vm.ruleForm.destiny.state.length === 0)
        return this.$message({ type: "error", message: "Estado de origem ou estado de destino é obrigatório!" });

      vm.$emit(vm.edition ? "edit" : "add", {
        ...vm.ruleForm,
      });
      vm.dialog = false;
    },
  },
  components: { StateList, CapitalStateList }
};
</script>

<style>
.uppercase {
  text-transform: uppercase;
}
</style>